export default () => ({
    title: '',
    titleShort: '',
    filter: ''
});
